import React, { useState, useContext } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Add from "../../../../icons/add.svg";
import Delete from "../../../../icons/delete.svg";
import { Pencil } from "lucide-react";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { UsuarioContext } from "../../../../providers/userContext";
import BreadCrumb from "../../../../components/navbar/Breadcrumb";
import { Box } from "@mui/material";
import { DataTable } from "../../../../components";
import { useNavigate } from "react-router-dom";
import { construirURLParamsFiltros, useRecogerURLParamsFiltros } from "../../../../functions/parametrosURL/funcionesParamsURL";
import { withRouter } from "../../../../providers/withRouter";
import { getCategoriasKae, deleteCategoriaKae } from "../../../../services";

const Categorias = () => {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const { filtroOrder } = useRecogerURLParamsFiltros();
  const user = useContext(UsuarioContext);
  const [loading, setLoading] = useState(true);
  const [recargar, setRecargar] = useState(true);
  const [data, setData] = useState({
    meta: {},
    rows: [],
  });

  const fetchData = async ({ offset, limit, filtros = {}, order, orderBy } = {}) => {
    orderBy = orderBy || filtroOrder.ordenadoPor || 'id';
    order = order || filtroOrder.orden || 'ASC';

    construirURLParamsFiltros(navigate, offset || 1, limit || 50, filtros, order, orderBy);

    try {
      setLoading(true);
      const response = await getCategoriasKae();
      const items = Array.isArray(response) ? response : [];
      setData({
        meta: {
          total: items.length,
          per_page: items.length,
          last_page: 1,
          has_more_pages: false,
        },
        rows: formatData(items),
      });
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const formatData = (data) => {
    return data.map((row) => ({
      id: row.id,
      nombre: row.nombre,
      descripcion: row.descripcion,
    }));
  };

  const categoriasHeaders = [
    {
      id: "nombre",
      numeric: false,
      disablePadding: false,
      label: t('categories.columns.name'),
    },
    {
      id: "descripcion",
      numeric: false,
      disablePadding: false,
      label: t('categories.columns.description'),
    },
    {
      id: "acciones",
      numeric: false,
      disablePadding: false,
      label: "",
      noObjeto: true,
      overrideFunc: (data, row) => (
        <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
          {(user.rol === "ADMIN" || user.rol === "VENT" || user.rol === "TECH" || user.rol === "TECH_COOR") && (
            <Link to={`/categorias/editar/${row.id}`}>
              <Pencil size={20} className="tableIcon" />
            </Link>
          )}
          {(user.rol === "ADMIN" || user.rol === "TECH" || user.rol === "TECH_COOR") && (
            <img
              src={Delete}
              alt={t('actions.delete')}
              className="tableIcon"
              onClick={() => eliminarCategoria(row)}
            />
          )}
        </div>
      ),
    },
  ];

  const eliminarCategoria = (cat) => {
    Swal.fire({
      title: t('categories.messages.confirmDelete'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      cancelButtonText: t('actions.cancel'),
      confirmButtonText: t('messages.yesDelete'),
    })
      .then((result) => {
        if (result.isConfirmed) {
          deleteCategoriaKae(cat.id)
            .then((res) => {
              if (res.message === "CATEGORIA_KAE_ELIMINADA") {
                toast.success(t('categories.messages.deleted'));
                setRecargar(!recargar);
              } else {
                toast.error(t('categories.messages.deleteError'));
              }
            })
            .catch((e) => {
              toast.error(t('categories.messages.deleteError'));
              console.log(e);
            });
        }
      })
      .catch((e) => {
        toast.error(t('messages.error'));
        console.log(e);
      });
  };

  return (
    <>
      <BreadCrumb rutas={[{ path: "/categorias", label: t('categories.title') }]} />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">
            {t('categories.title').toUpperCase()}
          </div>
        </div>
      </div>
      <div className="pageContent tableContainer">
        <div className="contentBar">
          <div style={{ display: "flex" }}></div>
          {(user.rol === "ADMIN" || user.rol === "VENT" || user.rol === "TECH" || user.rol === "TECH_COOR") && (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "end" }}>
              <Link to="/categorias/nueva">
                <div className="contentButton mx-2">
                  <img src={Add} alt={t('categories.new')} />
                </div>
              </Link>
            </div>
          )}
        </div>
        <div className="tableWrapper">
          <Box className="pageContent">
            <Box sx={{ mb: 10 }}>
              <DataTable
                data={data.rows}
                isLoading={loading}
                headers={categoriasHeaders}
                fetcher={fetchData}
                currentPage={data.current_page}
                meta={data.meta}
                totalItems={data.total}
                totalPages={data.totalPages}
                nextPage={data.next_page}
                mensaje={t('categories.messages.noCategories')}
                recargar={recargar}
                clicable={(user.rol === "ADMIN" || user.rol === "VENT" || user.rol === "TECH" || user.rol === "TECH_COOR")}
                onClickRow={(row) => (user.rol === "ADMIN" || user.rol === "VENT" || user.rol === "TECH" || user.rol === "TECH_COOR") && navigate(`/categorias/editar/${row.id}`)}
              />
            </Box>
          </Box>
        </div>
      </div>
    </>
  );
};

export default withRouter(Categorias);
